import { Paper, IconButton, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import LoadingSimpleBackdrop from '../../tools/LoadingSimpleBackdrop';
import Message from '../../tools/Message';
import Title from '../../../components/Title';
import {makeStyles, Tooltip } from '@material-ui/core';
import TimeSheetMissionService from '../../../services/TimeSheetMissionService';
import HistoryIcon from '@mui/icons-material/History';
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import SendTwoToneIcon from '@mui/icons-material/SendTwoTone';
import DownloadTwoToneIcon from '@mui/icons-material/DownloadTwoTone';
import UndoIcon from '@mui/icons-material/Undo';
import { useNavigate } from 'react-router';
import TimesheetSend from './TimesheetSend';
import { DataGrid } from '@mui/x-data-grid';
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import TimesheetShareDialog from './TimesheetShareDialog';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    elevation: 2,
    borderRadius: "8px",
    marginTop: "1%",
    height: "60%",
    boxShadow: "box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;",
  },
  btn: {
    margin: "1% 0.25% 1% 0.25%",
    fontWeight: 600,
  },
}));

const TimesheetTable = (props) => {
    const { filter, setReference } = props;
    const navigate = useNavigate();
    const classes = useStyles();
    const [openLoadingSimpleBackdrop, setOpenLoadingSimpleBackdrop] = useState(false);
    const [rows, setRows] = useState([]);
    const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 10 });
    const [message, setMessage] = useState({
         open: false,
         color: 'green',
         messageInfo: '',
    });
    const [confirmDialog, setConfirmDialog] = useState({
      open: false,
      mission_planning_id: null,
      agenda_id: null,
      timesheet_id: null,
    });
    const [openShareDialog, setOpenShareDialog] = useState({open: false, mission_timesheet_id: null, mission_planning_agenda_id: null, mission_planning_id: null});
    const [openActivateDialog, setOpenActivateDialog] = useState({open: false, mission_timesheet_id: null});
    const { open, color, messageInfo } = message;
    const STATE_TIMESHEET = [
    { label: 'Nouveau', value: null, color: '#33ccff' },
    { label: 'Elaboré', value: 'PLANNING', color: 'orange' },
    { label: 'En attente de validation', value: 'PENDING', color: 'purple' },
    { label: 'Validé', value: 'CONFIRMED', color: 'green' },
    { label: 'Refusé', value: 'REFUSED', color: 'red' },
    { label: 'Tous', value: '', color: '#33ccff' }
  ];
    
     function handleCloseMessage() {
      setMessage({ ...message, open: false });
    }

    const fetchData = async () => {
      setOpenLoadingSimpleBackdrop(true);
      try{
        const response = await TimeSheetMissionService.findMissionsTimesheetByFilter(filter);
        if(response && response.status){
          setRows(response.data.map((item, index) => ({
            id: index,
            ...item
          })));
          const references = [...new Set(response.data.map(item => item.reference))];
          setReference(references);
        setMessage({ open: true, color: 'green', messageInfo: 'Données chargées avec succès.' });
          return;
        }

        setRows([]);
        setMessage({ open: true, color: 'orange', messageInfo: 'Aucun enregistrement trouvé.' });
      }catch(err){
        setMessage({ open: true, color: 'red', messageInfo: 'Erreur lors du chargement des données.' });
      }finally{
        setOpenLoadingSimpleBackdrop(false);
      }

    };

    useEffect(() => {
      fetchData();
    }, [filter]);

    useEffect(() => {
      if(confirmDialog.open === false){
        fetchData();
      }
    }, [confirmDialog.open]);

    
    const handleShowActivateDialog = (mission_timesheet_id) => {
      setOpenActivateDialog({ open: true, mission_timesheet_id });
    };

    const handleActivateTimesheet = async (mission_timesheet_id) => {
      setOpenActivateDialog({ open: false, mission_timesheet_id: null });
      setOpenLoadingSimpleBackdrop(true);
      try{
        const response = await TimeSheetMissionService.activateTimesheet(mission_timesheet_id, 'PLANNING');
      
        if(response && response.status){
          setMessage({ open: true, color: 'green', messageInfo: 'Le timesheet a été réactivé avec succès.' });
          fetchData();
        }
      }catch(err){
        setMessage({ open: true, color: 'red', messageInfo: 'Erreur lors de la réactivation du timesheet.' });
      }
      setOpenLoadingSimpleBackdrop(false);
    };

  const columns = [
  { field: 'reference', headerName: 'Référence', width: 140 },
  {
    field: 'mission_title',
    headerName: 'Objet de la mission',
    width: 280
  },
  { field: 'lieu', headerName: 'Destination', width: 220 },
  {
    field: 'date_begin',
    headerName: 'Date début',
    width: 120,
    renderCell: (params) => (
      <>{new Date(params.row.date_begin).toLocaleDateString()}</>
    ),
  },
  {
    field: 'date_end',
    headerName: 'Date fin',
    width: 120,
    renderCell: (params) => (
      <>{new Date(params.row.date_end).toLocaleDateString()}</>
    ),
  },
  {
    field: 'mission_timesheet_state',
    headerName: 'Statut timesheet',
    width: 160,
    renderHeader: () => (
      <strong>
        Statut{"\n"}timesheet
      </strong>
    ),
    renderCell: (params) => (
      <span style={{
        color:
          STATE_TIMESHEET.find(option => option.value === params.row.mission_timesheet_state)?.color ||
          '#33ccff',
        fontSize: '13px',
        textAlign: 'center',
      }}>
        {STATE_TIMESHEET.find(option => option.value === params.row.mission_timesheet_state)?.label || 'Nouveau'}
      </span>
    )
  },
   {
    field: 'action',
    headerName: 'Actions',
    width: 180,
    renderCell: (params) => (
      <>
        {
          (params.row.mission_timesheet_state === 'PLANNING' || params.row.mission_timesheet_state === 'REFUSED' || params.row.mission_timesheet_state === null) &&
        <IconButton color="info" aria-label="edit" label="Elaborer le timesheet du mission" component="span" variant="outlined"
         onClick={() => navigate(`/mission/timesheet/add/${params.row.mission_planning_id}/${params.row.mission_planning_agenda_id}/${params.row.mission_timesheet_id}`)} size='small'>
          <EditTwoToneIcon />
          </IconButton>
    }
          {
            (params.row.mission_timesheet_state === 'PLANNING' || params.row.mission_timesheet_state === 'REFUSED') &&
       <Tooltip title="Envoyer le timesheet du mission pour validation" placement="top">
            <IconButton color="success" aria-label="send" label="Envoyer le timesheet du mission pour validation" component="span" variant="outlined" size='small' onClick={() => setConfirmDialog({
          open: true,
          mission_planning_id: params.row.mission_planning_id,
          agenda_id: params.row.mission_planning_agenda_id,
          timesheet_id: params.row.mission_timesheet_id,
        })}
        >
          <SendTwoToneIcon />
          </IconButton>
          </Tooltip>
    }
          {
            params.row.mission_timesheet_state === 'PENDING' &&
            <Tooltip title="Annuler la demande de validation et réactiver le timesheet pour modification" placement="top">
          <IconButton color="error" aria-label="undo" label="reactiver le timesheet du mission" component="span" variant="outlined" size='small' onClick={() => handleShowActivateDialog(params.row.mission_timesheet_id)} title='annuler la demande'>
            <UndoIcon />
            </IconButton>
        </Tooltip>
        }
            {
            ['CONFIRMED', 'PENDING'].includes(params.row.mission_timesheet_state) &&
            <Tooltip title="Télécharger le timesheet du mission" placement="top">
          <IconButton color="warning" aria-label="edit" label="Enregistrer le timesheet du mission" component="span" variant="outlined" size='small' onClick={() => handleDownloadFile(params.row.mission_planning_id, params.row.mission_planning_agenda_id, params.row.mission_timesheet_id)}>
          <DownloadTwoToneIcon />
          </IconButton>
          </Tooltip>
        }
        {
            // params.row.mission_timesheet_state !== null &&
            <Tooltip title="Afficher l'historique des modifications du timesheet" placement="top">
           <IconButton 
                title="Historique des modifications"  
                size="small" 
                variant="outlined"                
                color="info" 
                onClick={() => navigate(`/mission/timesheet/history/${params.row.mission_timesheet_id}/${params.row.mission_planning_agenda_id}`)}
              >
                <HistoryIcon /> 
              </IconButton>
              </Tooltip>
        }

        {
          ((params.row.mission_timesheet_state === 'PLANNING'  || params.row.mission_timesheet_state === null) && params.row.partage_id === null) &&
          <IconButton 
               title="Partager le timesheet"  
               size="small"
                variant="outlined"
                color="secondary"
                onClick={() => setOpenShareDialog({
                  open: true,
                  mission_timesheet_id: params.row.mission_timesheet_id,
                  mission_planning_agenda_id: params.row.mission_planning_agenda_id,
                  mission_planning_id: params.row.mission_planning_id,
                })}
              >
                <ShareOutlinedIcon /> 
              </IconButton>
        }
      </>
    )
  },
];

const handleDownloadFile = async (mission_planning_id, mission_planning_agenda_id, mission_timesheet_id) => {
  setOpenLoadingSimpleBackdrop(true);
  try{
    const response = await TimeSheetMissionService.downloadTimesheetFile(mission_planning_id, mission_planning_agenda_id, mission_timesheet_id);
    if(response){
      const fileURL = window.URL.createObjectURL(new Blob([response], { type: 'application/zip' }));
      const fileLink = document.createElement('a');
      fileLink.href = fileURL;
      fileLink.setAttribute('download', `timesheet_${mission_timesheet_id}.zip`);
      document.body.appendChild(fileLink);
      fileLink.click();
      fileLink.remove();
      window.URL.revokeObjectURL(fileURL);
      setMessage({ open: true, color: 'green', messageInfo: 'Le fichier a été téléchargé avec succès.' });
    }
  }catch(err){
    setMessage({ open: true, color: 'red', messageInfo: 'Erreur lors du téléchargement du fichier.' });
  }
  setOpenLoadingSimpleBackdrop(false);
};

return (
    <>
        <LoadingSimpleBackdrop openLoadingSimpleBackdrop={openLoadingSimpleBackdrop} />
        <Message open={open} color={color} messageInfo={messageInfo} handleClose={handleCloseMessage} />
              <Paper className={classes.paper} variant="outlined">
          <Title>Elaboration timesheet</Title>
                <div style={{ height: 640, width: '100%' }}>
            <DataGrid
                rows={rows}
                columns={columns}
                paginationModel={paginationModel}
                onPaginationModelChange={setPaginationModel}
                pageSizeOptions={[10]}
                pagination
                disableSelectionOnClick
                getRowId={(row) => row.id}
            />
            </div>
            </Paper>
            <Dialog open={openActivateDialog.open} onClose={() => setOpenActivateDialog({ open: false, mission_timesheet_id: null })}>
              <DialogTitle id="form-dialog-title" style={{ color: "white" }}><UndoIcon sx={{fontSize: "23px!important"}}/> Réactiver le timesheet</DialogTitle>
              <DialogContent dividers>
                <DialogContentText>
                 Êtes-vous sûr de vouloir <strong>réactiver</strong> le timesheet pour <strong>modification</strong> ?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setOpenActivateDialog({ open: false, mission_timesheet_id: null })} color="error" variant='outlined'>
                  Annuler
                </Button>
                <Button onClick={() => handleActivateTimesheet(openActivateDialog.mission_timesheet_id)} color="info" variant='contained'>
                  Réactiver
                </Button>
              </DialogActions>
            </Dialog>

          <TimesheetShareDialog open={openShareDialog.open} onClose={() => setOpenShareDialog({open: false, mission_timesheet_id: null, mission_planning_agenda_id: null, mission_planning_id: null})} mission_timesheet_id={openShareDialog.mission_timesheet_id} mission_planning_agenda_id={openShareDialog.mission_planning_agenda_id} mission_planning_id={openShareDialog.mission_planning_id} />
            <TimesheetSend confirmDialog={confirmDialog} setConfirmDialog={setConfirmDialog} setMessage={setMessage} />
    </>
);
};
export default TimesheetTable;
